<ng-container [formGroup]="formParent">
    <div class="form-group" [ngClass]="{'has-error': control?.dirty && control?.invalid}">
        <label class="control-label" [for]="frmControl" *ngIf="isLabelTop">{{label}}</label>
        <div class="checkbox-wrapper">
            <input type="checkbox" 
                   [id]="frmControl" 
                   [formControlName]="frmControl" 
                   [(ngModel)]="control.value" 
                   (change)="onCheckboxChange($event.target.checked)">
            <span class="checkbox-custom-dummy" style="margin-left: 10px;">{{label}}</span>
            <!-- <label class="form-label" [for]="frmControl">{{label}}</label> -->
        </div>
        <!-- <label class="form-label" [for]="frmControl" *ngIf="!isLabelTop">{{label}}</label> -->
    </div>
</ng-container>